<template>
  <div>
    <template v-if="renderedFrom === 'admin'">
      <button class="button is-primary is-small" :class="{ 'is-loading': isSending }" @click="getInvoices">
        <span>Refresh</span>
      </button>
    </template>
    <template v-if="invoices.length">
      <table class="table">
        <thead>
          <tr>
            <th>Invoice Date</th>
            <th>Number</th>
            <th>Description</th>
            <th>Amount</th>
            <th>Currency</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(invoice, i) in invoices" :key="`invoice_${i}`">
            <td>{{ invoice.createdAt | dateFormatNoTime }}</td>
            <td>10305</td>
            <td>{{ invoice.description }}</td>
            <td class="has-text-right">{{ (invoice.amount / 100) | formatAsCurrency }}</td>
            <td class="has-text-centered" style="text-transform: uppercase">{{ invoice.currency }}</td>
            <td><a target="_blank" class="cursor-pointer" @click="selectInvoice(invoice)">View</a></td>
          </tr>
        </tbody>
      </table>
    </template>
    <invoice-detail v-if="selectedInvoice" :invoice="selectedInvoice" :show-invoice="showInvoiceDetail" @close="showInvoiceDetail = false"/>
  </div>
</template>

<script>
import { buildEndpoint } from '../../../libs/buildEndPoint';
import InvoiceDetail from '@/views/organisation/billing/invoiceDetail.vue';

export default {

  components: {
    InvoiceDetail,
  },
  props: {
    organisation: Object,
    renderedFrom: String,
  },

  data() {
    return {
      invoices: [],
      error: null,
      isSending: false,
      showInvoiceDetail: false,
      selectedInvoice: null,
    };
  },

  mounted() {
    this.getInvoices();
  },

  methods: {
    getInvoices() {
      // eslint-disable-next-line no-underscore-dangle
      const _this = this;
      const endpoint = this.renderedFrom === 'admin'
        ? `admin/organisations/billing/invoices/${this.organisation._id}`
        : 'organisation-admin/organisation/billing/customer/invoices';
      _this.isSending = true;
      _this.$http
        .get(buildEndpoint(endpoint))
        .then((response) => {
          _this.isSending = false;
          if (response.data.success) {
            _this.invoices = response.data.data.invoices;
          } else {
            _this.error = `Error getting invoices: ${response.data.error}`;
          }
        })
        .catch((error) => {
          _this.isSending = false;
          _this.error = error;
        });
    },
    selectInvoice(invoice) {
      this.selectedInvoice = invoice;
      this.showInvoiceDetail = true;
    },
  },
};
</script>

<style lang="scss" scoped=""></style>
